import { NestedTreeControl } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, Component, Inject, Input, OnChanges } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { CertLogicItemResponse, CertLogicItemType } from '@ats/api/cm';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';
import { LOC_INJECTOR, LocalizationProvider } from '@cm/core/localization';
import {
	CPCertLogicTreeLocKeys,
	cpCertLogicTreeLocs,
	SPCertLogicTreeLocKeys,
	spCertLogicTreeLocs,
} from './cm-cert-logic-tree.locs';

@Component({
	selector: 'cm-cert-logic-tree',
	templateUrl: './cm-cert-logic-tree.component.html',
	styleUrls: ['./cm-cert-logic-tree.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		LocalizationProvider({
			...spCertLogicTreeLocs,
			...cpCertLogicTreeLocs,
		}),
	],
	standalone: false,
})
export class CmCertLogicTreeComponent implements OnChanges {
	treeControl = new NestedTreeControl<CertLogicItemResponse>(node => node.children);
	dataSource = new MatTreeNestedDataSource<CertLogicItemResponse>();
	@Input() data: CertLogicItemResponse;
	@Input() treeInitiallyClosed: boolean = false;
	@Input() catalog: boolean = false;
	types = CertLogicItemType;
	readonly locFeature: PortalCoreFeature;

	constructor(
		private settings: CmSettingsService,
		@Inject(LOC_INJECTOR)
		public readonly locs: SPCertLogicTreeLocKeys & CPCertLogicTreeLocKeys
	) {
		this.locFeature = this.settings.portalCoreFeature;
	}

	ngOnChanges(): void {
		this.treeControl.dataNodes = [this.data];
		this.dataSource.data = [this.data];
		if (!this.treeInitiallyClosed) {
			this.treeControl.expandAll();
		}
	}

	hasChild(_: number, node: CertLogicItemResponse): boolean {
		return !!node.children && node.children.length > 0;
	}

	formatLeafName(item: CertLogicItemResponse): string {
		if (item.certCatalog) {
			return item.certCatalog.nameAbbr
				? `${item.certCatalog.name} (${item.certCatalog.nameAbbr})`
				: item.certCatalog.name;
		} else if (item.certRequirementCatalog) {
			return item.certRequirementCatalog.name;
		} else if (item.examCatalog) {
			return item.examCatalog.externalId
				? `(${item.examCatalog.externalId}) ${item.examCatalog.name}`
				: item.examCatalog.name;
		} else if (item.examGroup && !item.examCatalog) {
			return item.examGroup.name;
		}
	}
}
